import { UPDATE_SUBMIT_REQUEST, UPDATE_LOADING_CONTACT_US } from '../actions/types'

const initialState = {
  loading: false,
  applyRequest: {
    name: '',
    companyName: '',
    email: '',
    phone: '',
    interest: '',
    budget: '',
    message: ''
  }
}

const contactUs = (state = initialState, action) => {
    const { type, payload } = action
   
    switch (type) {
      case UPDATE_LOADING_CONTACT_US:
        return {
          ...state,
          loading: payload
        }
      case UPDATE_SUBMIT_REQUEST:
        return {
          ...state,
          applyRequest: {
            ...state.applyRequest,
            [payload.name]: payload.value
          }
        }
      default:
        return state
    }
  }
   
  export default contactUs